import { Controller } from "@hotwired/stimulus"

// The rate sheet editor: "Add tier" appends a blank grid row from the template (its __INDEX__
// becomes a unique key so the row posts as its own tiers[<n>] entry); "Remove" drops a row.
export default class extends Controller {
  static targets = ["rows", "template"]

  add() {
    const html = this.templateTarget.innerHTML.replaceAll("__INDEX__", String(Date.now()))
    this.rowsTarget.insertAdjacentHTML("beforeend", html)
    this.rowsTarget.lastElementChild.querySelector("input")?.focus()
  }

  remove(event) {
    event.target.closest("tr").remove()
  }
}
